import { Controller } from "@hotwired/stimulus"

// Paywall modal — ouverture : data-action / paywall:open
// Achat pack : POST token_purchase_stub (simulation, remplacée plus tard par Stripe).

export default class extends Controller {
  static targets = ["dialog", "confirmDialog", "confirmMessage", "errorBanner"]
  static values = {
    purchaseUrl: String,
    errorGeneric: String
  }

  connect() {
    this._boundOpen = this._onGlobalOpen.bind(this)
    document.addEventListener("paywall:open", this._boundOpen)
    this._lastBalance = null
  }

  disconnect() {
    document.removeEventListener("paywall:open", this._boundOpen)
  }

  open(event) {
    event?.preventDefault()
    this._hideError()
    this.dialogTarget.showModal()
    document.body.style.overflow = "hidden"
  }

  close(event) {
    event?.preventDefault()
    this.dialogTarget.close()
    document.body.style.overflow = ""
  }

  backdropClick(event) {
    const rect = this.dialogTarget.getBoundingClientRect()
    const outside =
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom

    if (outside) this.close()
  }

  async purchasePack(event) {
    event.preventDefault()
    const amount = Number.parseInt(event.params.tokens, 10)
    if (!Number.isFinite(amount) || amount <= 0) return

    this._hideError()
    const btn = event.currentTarget
    const prevDisabled = btn.disabled
    btn.disabled = true

    try {
      const res = await fetch(this.purchaseUrlValue, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this._csrfToken
        },
        body: JSON.stringify({ amount })
      })

      const data = await res.json().catch(() => ({}))

      if (!res.ok) {
        const msg = (data && data.error) || this.errorGenericValue
        this._showError(msg)
        return
      }

      this._lastBalance = data.balance
      this.dialogTarget.close()
      this.confirmMessageTarget.textContent = data.message || ""
      this.confirmDialogTarget.showModal()
    } catch (_e) {
      this._showError(this.errorGenericValue)
    } finally {
      btn.disabled = prevDisabled
    }
  }

  closeConfirm(event) {
    event?.preventDefault()
    this.confirmDialogTarget.close()
    document.body.style.overflow = ""
    if (this._lastBalance != null) {
      document.dispatchEvent(
        new CustomEvent("tokens:balance-updated", { detail: { balance: this._lastBalance } })
      )
    }
    this._lastBalance = null
  }

  confirmBackdropClick(event) {
    const rect = this.confirmDialogTarget.getBoundingClientRect()
    const outside =
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom

    if (outside) this.closeConfirm()
  }

  get _csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || ""
  }

  _onGlobalOpen() {
    this._hideError()
    this.dialogTarget.showModal()
    document.body.style.overflow = "hidden"
  }

  _showError(message) {
    if (!this.hasErrorBannerTarget) return
    this.errorBannerTarget.textContent = message
    this.errorBannerTarget.hidden = false
  }

  _hideError() {
    if (!this.hasErrorBannerTarget) return
    this.errorBannerTarget.textContent = ""
    this.errorBannerTarget.hidden = true
  }
}
